import React, { useRef, useEffect } from "react";
import { Form, Input, Button, Modal } from "antd";
import { useTranslation } from "react-i18next";

const CreateGroupModel = ({ form, isShow, onFinish, onCancel }) => {
  const inputRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (isShow) {
      inputRef.current.focus({
        cursor: "start",
      });
    }
  }, [isShow]);
  return (
    <>
      <Modal
        title={t("createGroup")}
        open={isShow}
        onCancel={onCancel}
        footer={null}
      >
        <Form form={form} onFinish={onFinish}>
          <Form.Item
            style={{ height: "45px" }}
            name="groupName"
            label={t("groupName")}
            rules={[{ required: true, message: t("validateGroupName") }]}
          >
            <Input placeholder={t("placeHolderGroupName")} ref={inputRef} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {t("save")}
            </Button>
            <Button
              style={{ marginLeft: "10px" }}
              type="danger"
              onClick={onCancel}
            >
              {t("cancel")}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CreateGroupModel;
